import FieldSet from '../../FieldSet';

import { Tags } from './Tags';

export class TagsFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [Tags];
  }

  get title() {
    return 'Tags';
  }
}
